// 公司Id
let companyId = 0
// 文件路径
const staticFileUrl = window.options.staticFileUrl
// 设置文件公司Id
export const setCompanyId = (parameter) => {
  companyId = parameter
  localStorage.setItem('companyId', parameter)
}
// 获取指定照片
export const getSpecified = (name, label) => {
  if (label === 'company') {
    // 公司Logo
    const timestamp = new Date().getTime()
    return staticFileUrl + '/Logo/' + name + '?timestamp=' + timestamp
  } else if (label === 'user') {
    // 登录用户
    const timestamp = new Date().getTime()
    return staticFileUrl + '/User/' + name + '?timestamp=' + timestamp
  } else if (label === 'employee') {
    // 员工照片
    const timestamp = new Date().getTime()
    companyId = companyId === 0 ? localStorage.getItem('companyId') : companyId
    return staticFileUrl + '/Employees/' + companyId + '/' + name + '?timestamp=' + timestamp
  } else if (label === 'scene') {
    // 刷卡现场照片
    const timestamp = new Date().getTime()
    companyId = companyId === 0 ? localStorage.getItem('companyId') : companyId
    return staticFileUrl + '/TakePhotos/' + name + '?timestamp=' + timestamp
  } else if (label === 'visitor') {
    // 访客照片
    const timestamp = new Date().getTime()
    companyId = companyId === 0 ? localStorage.getItem('companyId') : companyId
    return staticFileUrl + '/Visitor/' + companyId + '/' + name + '?timestamp=' + timestamp
  } else if (label === 'execl') {
    // 导出的execl文件
    const timestamp = new Date().getTime()
    companyId = companyId === 0 ? localStorage.getItem('companyId') : companyId
    return staticFileUrl + '/Export/' + companyId + '/' + name + '?timestamp=' + timestamp
  } else if (label === 'execlTemplate') {
    // execl模板文件
    const timestamp = new Date().getTime()
    return staticFileUrl + '/File/Execl/' + name + '?timestamp=' + timestamp
  }
}
// 获取指定照片
export const getExteriorSpecified = (name, label, itemCompanyId) => {
  if (label === 'visitor') {
    // 外部访客照片
    const timestamp = new Date().getTime()
    return staticFileUrl + '/Visitor/' + itemCompanyId + '/' + name + '?timestamp=' + timestamp
  }
}
